import { useEffect, useState } from 'react';
import { Row, Col, Form, Modal, Button } from 'react-bootstrap';
import moment from 'moment';
import { api } from '../../../../../services/api';
import { toast } from 'react-toastify';
import styles from '../../pa_checklist_followup.module.scss';
import { usePAChecklistFollowUp } from '../../pa_checklist_followup_context';
import TabelaResumoFup from './resumo_fup_tabela';

const filtroOptions = [
  { value: 101, label: 'Entrada Fiscal' },
  { value: 102, label: 'Verba' },
  { value: 103, label: 'Qtde de Peças' },
  { value: 104, label: 'Cont. Distinta de Produto' }
];

const ResumoFup = () => {
  const { showResumo, setShowResumo } = usePAChecklistFollowUp();
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState(101);
  const [dataInicio, setDataInicio] = useState(moment().subtract(1, 'weeks').format('YYYY-MM-DD'));
  const [dataLimite, setDataLimite] = useState(moment().format('YYYY-MM-DD'));
  const [loading, setLoading] = useState(false);

  const [porEntradaF, setPorEntradaF] = useState([]);
  const [porVerbaF, setPorVerbaF] = useState([]);
  const [porPecasF, setPorPecasF] = useState([]);
  const [porProdutosF, setPorProdutosF] = useState([]);

  const [porEntradaP, setPorEntradaP] = useState([]);
  const [porVerbaP, setPorVerbaP] = useState([]);
  const [porPecasP, setPorPecasP] = useState([]);
  const [porProdutosP, setPorProdutosP] = useState([]);

  const calcularPercentuais = (mapa, total, verba = false) =>
    Array.from(mapa.entries()).map(([status, valor]) => ({
      status,
      valor: valor,
      valor: verba ? new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      }).format(valor) : valor,
      percentual: total ? ((valor / total) * 100).toFixed(2) : '0.00'
    }));

  const [statusCadeiaFinalizados] = useState(['RESULTADO C.Q. DISPONÍVEL (FERRAMENTA ANTIGA)', 'RESULTADO C.Q. DISPONÍVEL']);

  useEffect(() => {
    if (!Array.isArray(dados) || dados.length === 0) {
      setPorEntradaF([]); setPorEntradaP([]);
      setPorVerbaF([]); setPorVerbaP([]);
      setPorPecasF([]); setPorPecasP([]);
      setPorProdutosF([]); setPorProdutosP([]);
      return;
    }

    const mapEntradaF = new Map(); const mapEntradaP = new Map();
    const mapVerbaF = new Map(); const mapVerbaP = new Map();
    const mapPecasF = new Map(); const mapPecasP = new Map();
    const mapProdutosF = new Map(); const mapProdutosP = new Map();
    const setUniqueProductsF = new Set(); const setUniqueProductsP = new Set();

    let totalEntradasF = 0; let totalEntradasP = 0;
    let totalVerbaF = 0; let totalVerbaP = 0;
    let totalPecasF = 0; let totalPecasP = 0;

    for (const item of dados) {
      const status = item.status_cadeia || ' - ';
      const verba = Number(item.verba) || 0;
      const qtde = Number(item.qtde_pecas) || 0;
      const produto = item.produto;

      if (statusCadeiaFinalizados.includes(item.status_cadeia)) {
        mapEntradaF.set(status, (mapEntradaF.get(status) || 0) + 1);
        totalEntradasF += 1;

        mapVerbaF.set(status, (mapVerbaF.get(status) || 0) + verba);
        totalVerbaF += verba;

        mapPecasF.set(status, (mapPecasF.get(status) || 0) + qtde);
        totalPecasF += qtde;

        const produtoKey = `${status}::${produto}`;
        if (!setUniqueProductsF.has(produtoKey)) {
          setUniqueProductsF.add(produtoKey);
          mapProdutosF.set(status, (mapProdutosF.get(status) || 0) + 1);
        }
        continue;
      }

      mapEntradaP.set(status, (mapEntradaP.get(status) || 0) + 1);
      totalEntradasP += 1;

      mapVerbaP.set(status, (mapVerbaP.get(status) || 0) + verba);
      totalVerbaP += verba;

      mapPecasP.set(status, (mapPecasP.get(status) || 0) + qtde);
      totalPecasP += qtde;

      const produtoKey = `${status}::${produto}`;
      if (!setUniqueProductsP.has(produtoKey)) {
        setUniqueProductsP.add(produtoKey);
        mapProdutosP.set(status, (mapProdutosP.get(status) || 0) + 1);
      }
    }

    setPorEntradaF(calcularPercentuais(mapEntradaF, totalEntradasF));
    setPorVerbaF(calcularPercentuais(mapVerbaF, totalVerbaF, true));
    setPorPecasF(calcularPercentuais(mapPecasF, totalPecasF));
    setPorProdutosF(calcularPercentuais(mapProdutosF, setUniqueProductsF.size));

    setPorEntradaP(calcularPercentuais(mapEntradaP, totalEntradasP));
    setPorVerbaP(calcularPercentuais(mapVerbaP, totalVerbaP, true));
    setPorPecasP(calcularPercentuais(mapPecasP, totalPecasP));
    setPorProdutosP(calcularPercentuais(mapProdutosP, setUniqueProductsP.size));
  }, [dados]);

  const buscarDados = async () => {
    setLoading(true);
    try {
      const res = await api.get('pa/checklist-fup/resumo', { params: { data_inicio: dataInicio, data_limite: dataLimite } });
      setDados([...res.data]);
    } catch (err) {
      toast.error('Erro ao buscar os dados necessários, por favor tente nomanete ou entre em contato com o suporte.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    buscarDados();
  }, []);

  const colunasDinamicas = {
    101: [
      { name: 'Status de Cadeia', selector: row => row.status, sortable: true, wrap: true, style: { justifyContent: 'flex-start' } },
      { name: 'Qtde. NF Entrada Fiscal', selector: row => row.valor, sortable: true },
      { name: '% Total', selector: row => `${row.percentual}%`, sortable: true }
    ],
    102: [
      { name: 'Status de Cadeia', selector: row => row.status, sortable: true, wrap: true, style: { justifyContent: 'flex-start' } },
      { name: 'Verba', selector: row => row.valor, sortable: true },
      { name: '% Total', selector: row => `${row.percentual}%`, sortable: true }
    ],
    103: [
      { name: 'Status de Cadeia', selector: row => row.status, sortable: true, wrap: true, style: { justifyContent: 'flex-start' } },
      { name: 'Qtde. de Peças', selector: row => row.valor, sortable: true },
      { name: '% Total', selector: row => `${row.percentual}%`, sortable: true }
    ],
    104: [
      { name: 'Status de Cadeia', selector: row => row.status, sortable: true, wrap: true, style: { justifyContent: 'flex-start' } },
      { name: 'Cont. Distinta de Produto', selector: row => row.valor, sortable: true },
      { name: '% Total', selector: row => `${row.percentual}%`, sortable: true }
    ]
  }

  return (
    <Modal
      show={showResumo}
      onHide={() => setShowResumo(false)}
      centered
      size="lg"
      backdropClassName={styles.backdrop_z_override}
    >
      <Modal.Header closeButton style={{ fontWeight: '500' }}>Resumo | Status Cadeia</Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Group controlId="filtroSelect">
              <Form.Label style={{ fontWeight: '500' }}>Em função de</Form.Label>
              <Form.Select value={filtro} onChange={e => setFiltro(parseInt(e.target.value))}>
                {filtroOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="dataLimite">
              <Form.Label style={{ fontWeight: '500' }}>Data Início</Form.Label>
              <Form.Control
                type="date"
                value={dataInicio}
                onChange={e => setDataInicio(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="dataLimite">
              <Form.Label style={{ fontWeight: '500' }}>Data Limite</Form.Label>
              <Form.Control
                type="date"
                value={dataLimite}
                onChange={e => setDataLimite(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <TabelaResumoFup
          colunasDinamicas={colunasDinamicas}
          filtro={filtro}
          porEntradaF={porEntradaF}
          porPecasF={porPecasF}
          porProdutosF={porProdutosF}
          porVerbaF={porVerbaF}
          porEntradaP={porEntradaP}
          porPecasP={porPecasP}
          porProdutosP={porProdutosP}
          porVerbaP={porVerbaP}
          loading={loading}
        />
        {/* <Tabela
          columns={colunasDinamicas[filtro]}
          data={filtro === 101 ? porEntradaF : filtro === 102 ? porVerbaF : filtro === 103 ? porPecasF : filtro === 104 ? porProdutosF : []}
          striped={true}
          pending={loading}
          pagination={false}
        /> */}
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{ fontWeight: '500' }}
          onClick={async () => {
            try {
              setLoading(true);
              const res = await api.get('pa/checklist-fup/resumo', { params: { data_inicio: dataInicio, data_limite: dataLimite } });
              setDados([...res.data]);
            } catch (e) {
              toast.error('Erro ao buscar os dados necessários, por favor tente nomanete ou entre em contato com o suporte.');
            } finally {
              setLoading(false);
            }
          }}
          disabled={loading}
        >
          {loading ? 'Carregando...' : 'Recarregar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ResumoFup;
